import { render } from "./Modal.vue?vue&type=template&id=4b2165c0&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=4b2165c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__